<template>
  <div>
    <nav class="ng-nav main-color-border">
      <div class="w1200">
        <div class="ng-all-category" v-on:mouseleave="hiddencategory()">
          <div class="ng-ac-title" v-on:mouseenter="showcategory()">
            <a href="javascript:;"
              ><i class="fa fa-list" aria-hidden="true"></i
            ></a>
          </div>
          <div
            v-show="isshow"
            style="width:1200px;position:absolute;padding-top:15px;"
          >
            <div class="pn-category">
              <div class="pn-category-menu">
                <ul class="pn-menu">
                  <li
                    class="pn-menulist"
                    v-for="(list, index) in classlist"
                    :key="index"
                    v-on:mouseenter="showsubclass(index)"
                    v-on:mouseleave="hiddensubclass(index)"
                  >
                    <div class="pn-class">
                      <div class="pn-classname">
                        <p class="pn-span1">
                          <a
                            :href="
                              CurrentEnvPrefix.main +
                                Common.getSourec().sitehost +
                                '/index.php?act=search&op=index&cate_id=' +
                                list.gc_id
                            "
                            >{{ list.gc_name }}</a
                          >
                        </p>
                        <div class="pn-span2" v-if="list.cn_classes.length > 0">
                          <a
                            :href="
                              CurrentEnvPrefix.main +
                                Common.getSourec().sitehost +
                                '/index.php?act=search&op=index&cate_id=' +
                                slist.gc_id
                            "
                            v-for="(slist, jindex) in list.cn_classes"
                            :key="jindex"
                            >{{ slist.gc_name }}
                          </a>
                        </div>
                        <div class="pn-span2" v-else>
                          <template v-if="index < 2">
                            <a
                              :href="
                                CurrentEnvPrefix.main +
                                  Common.getSourec().sitehost +
                                  '/index.php?act=search&op=index&cate_id=' +
                                  slist.gc_id
                              "
                              v-for="(slist, kindex) in list.children"
                              :key="kindex"
                              >{{ slist.gc_name }}
                            </a>
                          </template>
                        </div>
                      </div>
                    </div>
                    <div class="pn-subclass" v-show="isshow1 == index">
                      <div class="pn-subclass-main">
                        <div class="pn-subclass-content">
                          <ul class="pn-sc-list">
                            <li
                              class="pn-sc-item"
                              v-for="(slist, index) in list.children"
                              :key="index"
                            >
                              <a
                                :href="
                                  CurrentEnvPrefix.main +
                                    Common.getSourec().sitehost +
                                    '/index.php?act=search&op=index&cate_id=' +
                                    slist.gc_id
                                "
                                class="pn-scname1"
                                >{{ slist.gc_name }}</a
                              >
                              <ul class="pn-sc-ul">
                                <li
                                  class="pn-sc-li"
                                  v-for="sclass in slist.children"
                                  :key="sclass.gc_id"
                                >
                                  <a
                                    :href="
                                      CurrentEnvPrefix.main +
                                        Common.getSourec().sitehost +
                                        '/index.php?act=search&op=index&cate_id=' +
                                        sclass.gc_id
                                    "
                                    >{{ sclass.gc_name }}</a
                                  >
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="pn-store">
                <div class="pn-storelist">
                  <swiper
                    :options="swiperOption"
                    ref="mySwiper"
                    style="height:235px;"
                  >
                    <!-- slides -->
                    <swiper-slide
                      v-for="(list, index) in shoplist"
                      :key="index"
                    >
                      <a :href="list.ads[0].url" target="_blank">
                        <img :src="list.ads[0].pic" />
                        <p style="text-align:center;margin-top:10px;">
                          {{ list.store_name }}
                        </p>
                        <p style="text-align:center;">
                          <span
                            style="border:1px solid #FF3838;color:#ff3838;width:82px;height:20px;display:inline-block;text-align:center;line-height:20px;border-radius:12px"
                            >新进商家</span
                          >
                        </p>
                      </a>
                    </swiper-slide>
                    <!-- Optional controls -->
                    <div
                      class="swiper-pagination"
                      slot="pagination"
                      style="bottom:0;"
                    ></div>
                    <!-- <div class="swiper-button-prev  swiper-button-white" slot="button-prev" @click='slidePrev()'></div>
									    <div class="swiper-button-next  swiper-button-white" slot="button-next" @click='slideNext()'></div> -->
                  </swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ul class="site-menu">
          <li>
            <a
              href="javascript:void(0)"
              @click="
                hrefClick(CurrentEnvPrefix.main + Common.getSourec().sitehost)
              "
              >首页</a
            >
          </li>
          <li v-for="(list, index) in searchnavlist">
            <a :href="list.nav_url" target="_blank" ref="cxxp"
              >{{ list.nav_title }}<img :src="list.nav_image"
            /></a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<style type="text/css" scoped>
.site-menu .router-link-exact-active.router-link-active {
  color: #ff2d51;
}
.swiper-slide {
  float: left;
}
.swiper-button-white {
  display: none;
  width: 20px;
  height: 20px;
  background-size: 100%;
  top: 56%;
}
.pn-store:hover .swiper-button-white {
  display: block;
}
.pn-category .pn-span2 {
  display: flex;
  flex-flow: row wrap;
}
.pn-category .pn-span2 a {
  margin: 10px 15px 0 0;
}
.pn-category-menu {
  width: 1200px;
  position: relative;
}
/*.pn-menu{height: 450px;overflow-y: auto;}*/
.site-menu a {
  position: relative;
}
.site-menu a img {
  position: absolute;
  top: -2px;
  right: 2px;
  width: 30px;
}
</style>

<script>
// import './global/css/font-awesome/css/font-awesome.min.css'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
import "swiper/dist/css/swiper.css";
import { CurrentEnvPrefix } from "config/urlprefix.js";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  data() {
    return {
      CurrentEnvPrefix,
      isshow: false,
      isshow1: -1,
      classlist: [],
      shoplist: [],
      searchnavlist: [],
      swiperOption: {
        autoplay: true,
        direction: "horizontal",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets"
        },
        mousewheelControl: true
      }
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },

  methods: {
    showcategory() {
      this.isshow = true;
    },
    hiddencategory() {
      this.isshow = false;
    },
    showsubclass(index) {
      this.isshow1 = index;
    },
    hiddensubclass(index) {
      this.isshow1 = -1;
    },
    getClassList() {
      this.$Api
        .get({ api: this.Common.getSourec().plapi + "/goods_search/nav_list" })
        .then(response => {
          if (response.data.ResponseStatus == 0) {
            this.classlist = response.data.datas.cates;
          }
        });
    },
    hrefClick(href) {
      this.$HrefRouter.WebHrefRrouter(href);
    },
    getNavShop() {
      this.$Api.get({ api: "/ad/newshop/list" }).then(response => {
        this.shoplist = response.data.datas;
      });
    },
    getNavMenu() {
      this.$Api
        .get({
          api: this.Common.getSourec().plapi + "/goods_search/search_nav"
        })
        .then(response => {
          if (response.data.ResponseStatus == 0) {
            this.searchnavlist = response.data.datas;
          }
        });
    }
  },
  mounted() {
    this.getClassList();
    this.getNavShop();
    this.getNavMenu();
    var path = this.$route.path;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/public/publicnav1.vue